import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, map, finalize } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AuthService } from "../services/auth.service";
import { LoadingService } from "../services/loading.service";

@Injectable()
export class HttpConfig implements HttpInterceptor {

    constructor(private _auth: AuthService, private _loading: LoadingService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const isAbsolute = /^https?:\/\//i.test(req.url);
        // ไฟล์ static ในโปรเจกต์ (assets/) — โหลดตรงจาก origin ของแอป ไม่ต้องเติม apiURL
        const isAsset = /^\.?\/?assets\//i.test(req.url);
        const appendURL = (isAbsolute || isAsset) ? req.url : `${environment.apiURL}${req.url}`;
        // เติม Bearer เฉพาะ request ที่ยิงไป API ของเราเอง — ถ้าเป็น URL ภายนอกหรือ assets
        // อย่าเติม (assets ไม่ต้อง, ภายนอกเช่น github จะทำให้เกิด CORS preflight แล้วโดนบล็อก)
        const isOurApi = !isAbsolute && !isAsset || (isAbsolute && appendURL.startsWith(environment.apiURL));

        // global loading: นับเฉพาะ request ที่ยิงไป API ของเราเอง
        if (isOurApi) this._loading.start();

        return next
            .handle(req.clone({
                headers: isOurApi ? this.appendHeaders(req.headers) : req.headers,
                url: appendURL,
            }))
            .pipe(map(c => this.handleResponse(c)))
            .pipe(catchError(c => this.handleException(c)))
            .pipe(finalize(() => { if (isOurApi) this._loading.stop(); }));
    }

    /** handle response data */
    private handleResponse(response: HttpEvent<any>): any {
        if (response instanceof HttpResponse) {
            if (response.body && response.body.Token) {
                this._auth.setAccessToken(response.body);
                delete response.body.Token;
                delete response.body.Expires;

            }
        }
        return response;
    }


    /** append headers */
    private appendHeaders(headers: HttpHeaders) {
        if (this._auth.accessToken) headers = headers.append('Authorization', 'Bearer ' + this._auth.accessToken);
        return headers;
    }

    /** handle error exception */
    private handleException(res: HttpErrorResponse) {
        const _res: any = res;
        if (res.error && (res.error.message || res.error.Message)) {
            _res.message = res.error.message || res.error.Message;
        }
        // Unauthorization
        if (res.status == 401) {
            this._auth.removeAccessToken();
            location.reload();
        }
        return throwError(_res);
    }

}